import { BaseModel, type RelationConfig } from './base';

// Enums

export enum MinisiteOnlineBookingAllowCustomers {
  all = 0,
  none = 1,
}

export const MinisiteOnlineBookingAllowCustomersLabels: Record<MinisiteOnlineBookingAllowCustomers, string> = {
  [MinisiteOnlineBookingAllowCustomers.all]: 'minisite.preferences.onlineBookingAllowCustomersAll',
  [MinisiteOnlineBookingAllowCustomers.none]: 'minisite.preferences.onlineBookingAllowCustomersNone',
};

export enum MinisiteAllowInternetSelectEmployee {
  all = 0,
  none = 1,
  expanded = 2,
}

export const MinisiteAllowInternetSelectEmployeeLabels: Record<MinisiteAllowInternetSelectEmployee, string> = {
  [MinisiteAllowInternetSelectEmployee.all]: 'minisite.preferences.allowInternetSelectEmployeeAll',
  [MinisiteAllowInternetSelectEmployee.none]: 'minisite.preferences.allowInternetSelectEmployeeNone',
  [MinisiteAllowInternetSelectEmployee.expanded]: 'minisite.preferences.allowInternetSelectEmployeeExpanded',
};

export enum MinisiteWaitlistMode {
  all = 0,
  none = 1,
  expanded = 2,
}

export const MinisiteWaitlistModeLabels: Record<MinisiteWaitlistMode, string> = {
  [MinisiteWaitlistMode.all]: 'general.none',
  [MinisiteWaitlistMode.none]: 'minisite.preferences.waitlistModeNone',
  [MinisiteWaitlistMode.expanded]: 'minisite.preferences.waitlistModeExpanded',
};

export enum MinisiteOnlinePaymentDepositRequiredType {
  percentage = 0,
  fixed = 1,
}

export const MinisiteOnlinePaymentDepositRequiredTypeLabels: Record<MinisiteOnlinePaymentDepositRequiredType, string> = {
  [MinisiteOnlinePaymentDepositRequiredType.percentage]: 'general.percentage',
  [MinisiteOnlinePaymentDepositRequiredType.fixed]: 'general.fixed',
};

// Helper Classes

export class MinisitePreferences extends BaseModel {
  onlineBookingAllowCustomers!: MinisiteOnlineBookingAllowCustomers;
  allowInternetSelectEmployee!: MinisiteAllowInternetSelectEmployee;
  waitlistMode!: MinisiteWaitlistMode;
}

export class MinisitePaymentSettings extends BaseModel {
  onlinePaymentDepositRequiredType!: MinisiteOnlinePaymentDepositRequiredType;
}

export class MinisiteImage extends BaseModel {
  id!: number;

  override objectID(): string | null {
    return this.id?.toString() ?? null;
  }
}

// Main Model

export class Minisite extends BaseModel {
  preferences!: MinisitePreferences | null;
  paymentSettings!: MinisitePaymentSettings | null;

  static override relations(): RelationConfig {
    return {
      preferences: { type: MinisitePreferences },
      paymentSettings: { type: MinisitePaymentSettings },
    };
  }
}
